import {Request}                from '../../request.abstract';
import {Http}                   from '@angular/http';
import {Settings}               from '../../settings.model';
import {SettingsEndpoint}       from "./settings/api.service";
import {StatisticsEndpoint}     from "./statistics/api.service";
import {SchemasEndpoint}        from './schemas/api.service';
import {MessageCentralEndpoint} from './messagecentral/api.service';

export class ProxyEndpoint extends Request {
    protected baseId: number;

    constructor(http: Http, settings: Settings, baseId: number) {
        super(http, settings);
        this.baseId = baseId;
    }

    setting(): SettingsEndpoint {
        return new SettingsEndpoint(this.http, this.settings, this.baseId);
    }

    statistics(): StatisticsEndpoint {
        return new StatisticsEndpoint(this.http, this.settings, this.baseId);
    }

    schemas(): SchemasEndpoint {
        return new SchemasEndpoint(this.http, this.settings, this.baseId);
    }

    messagecentral(): MessageCentralEndpoint {
        return new MessageCentralEndpoint(this.http, this.settings, this.baseId);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/bases/proxy/api.service.ts